"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.reducer = exports.INITIAL_STATE = void 0;
var actions = __importStar(require("../actions/settings"));
var utils_1 = require("./utils");
var immer_1 = __importDefault(require("immer"));
// Reducer with initial state
exports.INITIAL_STATE = {
    user: null,
    commentsEnabled: false,
    currentTab: null,
};
exports.reducer = immer_1["default"](function (draft, action) {
    switch (action.type) {
        case actions.UPDATE_GLOBAL_SETTINGS:
            utils_1.update(draft, action.update);
            break;
        default:
            break;
    }
}, exports.INITIAL_STATE);
